import * as types from "./types";

export const resetGivingForm = () => ({
  type: types.RESET_GIVING_FORM,
});
